export const heroev6 = {
  title: 'Kia EV6',
  subTitle: '',
  src: 'https://kia-afonso-storage.b-cdn.net/kia/Vidderna_landningssida-2.mp4',
  srcWebm:
    'https://kia-afonso-storage.b-cdn.net/kia/Vidderna_landningssida_1920x800-2.webm',
};

export const headingEV6 = {
  heading: 'Vidden av frihet',
  headingSub: 'Kia Business Lease med garanterat restvärde fr. 4 272 kr/mån',
};

export const textBoxicon01 = {
  title: '',
  backgroundColor: '',
  numberOfFields: 3,
  titleStyle: 'mb-6 text-[32px] max-w-[627px]',
  textSize:
    'text-center leading-[24px] text-[16px] md:text[18px] font-light md:font-normal',
  listItems: [
    {
      text: 'Räckvidd upp till 582 km tack vare batteriets höga kapacitet.',
      boldParts: [''],

      iconProps: { color: '#000', width: 24, height: 24, strokeWidth: 5 },
    },
    {
      text: 'Ultrasnabb laddning 10–80 % på ner till 18 minuter med förfinad 800-voltsteknik.',
      boldParts: [''],
      iconProps: { color: '#000', width: 24, height: 24, strokeWidth: 5 },
    },
    {
      text: 'Smidigare laddstopp med Plug & Charge – anslut via Kia Charge.',
      boldParts: [''],
      iconProps: { color: '#000', width: 24, height: 24, strokeWidth: 5 },
    },
  ],
};

export const kiaImageEV601 = {
  src: 'https://kia-afonso-storage.b-cdn.net/Kia-behind-the-scenes/scen/KIA-BD-Spelning-007.jpg',
  alt: 'KIA Car',
  sizes: '(max-width: 768px) 100vw, 50vw',
  className: 'mx-auto pt-0 w-full ',
};

export const twoComponentsTextEV601 = {
  title: 'Kia EV6 och Mando Diao',
  text: 'Med upp till 582 km räckvidd, ultrasnabb laddning och Vehicle-to-Load ger Kia EV6 samma uttryck för frihet som musiken från Mando Diao som den ackompanjeras av. ',
};

export const linkEV601 = {
  text: 'Läs mer om EV6',
  textSize: '16px',
  url: 'https://www.kia.com/se/nya-bilar/ev6/upptack/',
  className: 'mt-6 mb-6 ',
  openInNewTab: false,
};

export const kiaImageEV602 = {
  src: 'https://kia-afonso-storage.b-cdn.net/Kia-behind-the-scenes/scen/KIA-BD-Spelning-011.jpg',
  alt: 'Kia behind the scenes',
  sizes: '(max-width: 768px) 100vw, 50vw',
  className: 'mx-auto pt-0 w-full ',
};

export const twoComponentsTextEV602 = {
  title: 'Laddad med Kia EV6',
  text: 'Utnyttja elbilens möjligheter till fullo. Med Vehicle-to-Load som enda strömkälla driver Kia EV6 en hemlig spelning med Mando Diao. Följ med bakom kulisserna och upp på scenen med ett av Sveriges främsta rockband och hör låten Vidderna, specialskriven för Kia.',
};

export const linkEV602 = {
  text: 'Se spelningen med Mando Diao ',
  textSize: '16x',
  url: 'https://www.kia.com/se/kopa/erbjudanden/ev6/vidderna',
  className: 'mt-6 mb-6 ',
  openInNewTab: false,
};

export const textBox2 = {
  title: 'Tekniken som tar Kia EV6 i mål',
  backgroundColor: '#000',
  numberOfFields: 3,
  textSize:
    'text-center leading-[24px] text-[16px] md:text[18px] font-light md:font-normal',
  titleStyle: 'mb-14 text-[40px] max-w-[717px] leading-[48px]',
  centerText: true,
  listItems: [
    {
      title: 'Räckvidd',
      text: 'Tack vare batteriets kapacitet på 84 kWh: räckvidd på upp till 546 km i EV6 AWD och upp till 582 km i EV6 RWD.',
    },
    {
      title: 'Sömlös laddning',
      text: 'Via Kia Charge kan du som kör EV6 ansluta till Plug & Charge och ladda smidigt utan betalkort eller appar vid Ionitys stationer. Allt du behöver göra är att ansluta laddkabeln.',
    },
    {
      title: 'Sist in, först ut',
      text: 'Kia EV6 laddar 10 till 80 procent på ner till 18 minuter. Allt tack vare den förfinade 800-voltstekniken. Det robusta batteriet är byggt för att tåla upprepade snabbladdningar. ',
    },
  ],
};

export const infobox01 = {
  title: 'Laddbar frihet, för fler.',
  image: {
    src: 'https://kia-afonso-storage.b-cdn.net/kia/EV_Range.jpg',
    alt: 'KIA Elbilar',
    sizes: '(max-width: 768px) 100vw, 50vw',
    className: 'mx-auto pt-0 w-full ',
  },
  text: 'Nu finns fler anledningar att välja en Kia som elbil. Kia EV6 kommer med en räckvidd på upp till 582 km och dessutom upp till 1 800 kg dragvikt. Kia EV3 är en rymlig kompakt SUV med en räckvidd på upp till 605 km och design inspirerad av EV9. Störst av våra elbilar är prisvinnande Kia EV9 med en räckvidd på upp till 512 km, plats för upp till sju och maximal dragvikt på upp till 2500 kg. Både Kia EV9 och Kia EV6 kommer med 800V-teknik som möjliggör ultrasnabb laddning.',
  links: [
    {
      text: 'Läs mer om Kia EV6',
      url: ' https://www.kia.com/se/nya-bilar/ev6/upptack/',
      className: 'w-[298px]',
      openInNewTab: false,
    },
    {
      text: 'Läs mer om Kia EV3',
      url: 'https://www.kia.com/se/nya-bilar/ev3/upptack/',
      className: 'w-[298px]',
      openInNewTab: false,
    },
    {
      text: 'Läs mer om Kia EV9',
      url: 'https://www.kia.com/se/nya-bilar/ev9/upptack/',
      className: 'w-[298px]',
      openInNewTab: false,
    },
  ],
  titleFontSize: 'text-[32px] md:text-[32px]',
  textFontSize: 'text-[16px] md:text[18px] font-light',
};

export const kiaImageEV603 = {
  src: 'https://kia-afonso-storage.b-cdn.net/Kia-behind-the-scenes/KIA-BD-EV6-Side.jpg',
  alt: 'Kia EV6',
  sizes: '(max-width: 768px) 100vw, 50vw',
  className: 'mx-auto pt-0 w-full ',
};

export const infobox02 = {
  title: 'Enkel finansiering ',

  text: 'Upptäck din nästa tjänstebil från Kia. Med Kia Business Lease kan du uppleva laddbar frihet i form av en välutrustad laddbar Kia inklusive försäkring, service, vinterhjul och med garanterat restvärde.',
  links: [
    {
      text: 'Hitta närmaste återförsäljare',
      url: 'https://www.kia.com/se/sok-aterforsaljare-verkstad/#/',
      className: 'border-2 border-black',
      openInNewTab: true,
      textColor: 'black',
      bgColor: 'white',
    },
    {
      text: 'Prislista',
      url: 'https://www.kia.com/se/kopa/prislista/',
      className: 'w-[298px]',
      openInNewTab: true,
    },
  ],
  gap: '5',
  titleFontSize: 'text-[32px] md:text-[32px]',
  textFontSize: 'text-[16px] md:text[18px] font-light',
};

export const infobox03 = {
  title: 'Finansiera din nästa tjänstebil ',
  image: {
    src: 'https://kia-afonso-storage.b-cdn.net/Kia-behind-the-scenes/KIA-BD-EV6-HERO-Car.jpg',
    alt: 'KIA Elbilar',
    sizes: '(max-width: 768px) 100vw, 50vw',
    className:
      'min-h-[290px] max-h-[290px] min-w-[330px] md:min-w-[380px] md:max-w[380px] object-cover object-center',
  },
  text: 'Kia Business Lease är en helhetslösning som innebär ett garanterat restvärde och inkluderar försäkring, service och Kia Original vinterhjul. Med Kia Finansiell leasing väljer du själv till de tjänster du behöver. ',
  links: [
    {
      text: 'Våra finanslösningar',
      url: 'https://www.kia.com/se/tjanstebil/foretagsleasing/',
      className: 'w-[298px]',
      openInNewTab: false,
    },
  ],
  headingPosition: 'below',
  titleFontSize: 'text-[22px]',
  textFontSize: 'text-[16px] font-light',
};

export const infobox04 = {
  title: 'Kia som tjänstebil',
  image: {
    src: 'https://kia-afonso-storage.b-cdn.net/Kia-behind-the-scenes/EV6_GTL_MY25_Exterior_Headlamps_CMYK.jpg',
    alt: 'KIA Elbilar',
    sizes: '(max-width: 768px) 100vw, 50vw',
    className:
      'min-h-[290px] max-h-[290px] min-w-[330px] md:min-w-[380px] md:max-w[380px] object-cover object-center',
  },
  text: 'Med en Kia som tjänstebil får du innovativ teknik, hög komfort och de senaste säkerhets- och infotainment-systemen med uppkopplade tjänster – samt flexibla finansieringslösningar.',
  links: [
    {
      text: 'Läs mer om Kia som tjänstebil',
      url: 'https://www.kia.com/se/tjanstebil/',
      openInNewTab: false,
    },
  ],
  headingPosition: 'below',
  titleFontSize: 'text-[22px]',
  textFontSize: 'text-[16px] font-light',
};

export const infobox05 = {
  title: 'Räkna på din nästa tjänstebil',
  image: {
    src: 'https://kia-afonso-storage.b-cdn.net/kia/tjanstebil.webp',
    alt: 'KIA Elbilar',
    sizes: '(max-width: 768px) 100vw, 50vw',
    className:
      'min-h-[290px] max-h-[290px] min-w-[330px] md:min-w-[380px] md:max-w[380px] object-cover object-center',
  },
  text: 'Jämför våra laddbara modeller och räkna på vad din nästa tjänstebil från Kia kommer att kosta.',
  links: [
    {
      text: 'Till tjänstebilskalkylatorn',
      url: 'https://www.kia.com/se/tjanstebil/kalkyl-laddhybrid/',
      className: 'w-[298px]',
      openInNewTab: false,
    },
  ],
  headingPosition: 'below',
  titleFontSize: 'text-[22px]',
  textFontSize: 'text-[16px] font-light',
};

export const infobox06 = {
  title: 'Bilmodeller',
  image: {
    src: 'https://kia-afonso-storage.b-cdn.net/100procent/Elbil-Laddbar-KIa.jpg',
    alt: 'KIA Elbilar',
    sizes: '(max-width: 768px) 100vw, 50vw',
    className:
      'min-h-[290px] max-h-[300px] min-w-[330px] object-cover object-center',
  },
  text: 'Upptäck vårt breda modellprogram med laddbara bilar som passar alla. ',
  links: [
    {
      text: 'Läs mer om våra bilmodeller',
      url: 'https://www.kia.com/se/nya-bilar/bilmodeller/',
      className: 'w-[298px]',
      openInNewTab: true,
    },
  ],
  headingPosition: 'below',
  titleFontSize: 'text-[22px]',
  textFontSize: 'text-[16px] font-light',
};

export const infobox07 = {
  title: 'Uppkopplade tjänster',
  image: {
    src: 'https://kia-afonso-storage.b-cdn.net/Kia-behind-the-scenes/EV6_GTL_MY25_LifstyleInterior_PhoneNavi_with_Talent_CMYK.jpg',
    alt: 'KIA Elbilar',
    sizes: '(max-width: 768px) 100vw, 50vw',
    className:
      'min-h-[290px] max-h-[300px] min-w-[330px] object-cover object-center',
  },
  text: 'Behåll kontakten med din bil, var du än är. Med appen Kia Connect får du körstatistik och status.',
  links: [
    {
      text: 'Läs mer om Kia Connect',
      url: 'https://www.kia.com/se/om-kia/upplev-kia/teknik/kia-connect/',
      className: 'w-[298px]',
      openInNewTab: true,
    },
  ],
  headingPosition: 'below',
  titleFontSize: 'text-[22px]',
  textFontSize: 'text-[16px] font-light',
};

export const infobox09 = {
  title: 'Kia Originaltillbehör',
  image: {
    src: 'https://kia-afonso-storage.b-cdn.net/Kia-behind-the-scenes/KIA_MG_1409.jpg',
    alt: 'KIA Elbilar',
    sizes: '(max-width: 768px) 100vw, 50vw',
    className:
      'min-h-[290px] max-h-[300px] min-w-[330px] object-cover object-center',
  },
  text: 'Oavsett om du behöver en högkvalitativ dragkrok, lasthållare eller takbox erbjuder Kia tillbehör som är speciellt tillverkade och anpassade för din Kia. ',
  links: [
    {
      text: 'Till Kia Originaltillbehör',
      url: 'https://www.kia.com/se/aga/originaldelar-oversikt/originaltillbehor/',
      className: 'w-[298px]',
      openInNewTab: true,
    },
  ],
  headingPosition: 'below',
  titleFontSize: 'text-[22px]',
  textFontSize: 'text-[16px] font-light',
};

export const greyListData = {
  title: 'Alltid i en Kia',
  underTitle: 'Följande ingår som standard i alla nya personbilar från Kia: ',
  items: [
    { text: 'Rattvärme' },
    { text: 'Backkamera' },
    { text: 'Metallic/pearl-lack' },
    { text: 'Värmepump och förvärmning av batteri och kupé (i elbilar)' },
    { text: 'Kia Assistans i samband med Kia Originalservice¹⁴' },
    { text: '7 års nybilsgaranti från fabrik¹¹' },
    { text: '7 års app-styrning (Kia App¹³)' },
    { text: '7 års garanti på Kia Original vinterhjul (tillval)' },
    { text: '7 års uppkopplad navigation med live-tjänster (Kia Live)' },
  ],
};

export const kiaImageEV605 = {
  src: 'https://kia-afonso-storage.b-cdn.net/Kia-behind-the-scenes/Range_Bjorkvik_2411212.jpg',
  alt: 'KIA Car',
  sizes: '(max-width: 768px) 100vw, 50vw',
  className: 'mx-auto pt-0 w-full ',
};

export const twoComponentsTextEV604 = {
  title: 'Erbjudande från Kia.',
  text: 'Just nu har vi förstärkta erbjudanden på flera populära elbilar och laddhybrider med privatleasing. Se även våra övriga erbjudanden för privatpersoner och företag. Välkommen in och upptäck den laddbara friheten med Kia.',
};

export const linkEV604 = {
  text: 'Läs mer om erbjudandena.',
  textSize: '16px',
  url: 'https://www.kia.com/se/kopa/erbjudanden/',
  className: 'mt-6 mb-6 ',
  openInNewTab: false,
};
